import $ from 'jquery';
import { BroadcastChannel } from 'broadcast-channel';

$(function () {
    $('#action-form').on('submit', function (event) {
        const $form = $(this);
        const $button = $(event.originalEvent.submitter);

        if (! $button.length) {
            return;
        }

        const method = $button.data('method') ?? 'POST';

        if (! $button.attr('formtarget')) {
            $button.addClass('is-pending');
        }

        if ($button.data('ajax')) {
            event.preventDefault();

            const dataType = $button.data('ajaxType') ?? 'json';

            $.ajax({
                url: $button.attr('formaction'),
                method: 'POST',
                data: method === 'POST' ? null : {_method: method},
                dataType: dataType,
            })
                .then(
                    function (response) {
                        if (dataType === 'json') {
                            if (typeof response === 'object') {
                                if (response.broadcast) {
                                    const channel = new BroadcastChannel(response.broadcast.channel);

                                    channel.postMessage(response.broadcast.message);
                                }

                                if (response.redirect) {
                                    location.href = response.redirect;

                                    // Keep button in "pending" state while redirect page is loading
                                    return $.Deferred();
                                }
                            }
                        } else if (dataType === 'html') {
                            $($button.data('ajaxTarget')).html(response);
                        }
                    },
                    function (xhr) {
                        const message = xhr.responseJSON?.message
                            || xhr.responseJSON?.exception
                            || (xhr.status + ' ' + xhr.statusText);

                        console.error(xhr);
                        notyf.error({message: message, duration: 0, dismissible: true});
                    },
                )
                .then(() => $button.removeClass('is-pending'));

            return;
        }

        $form.children('input[type=hidden][name=_method]').remove();

        if (method !== 'POST') {
            $form.append($('<input>', {type: 'hidden', name: '_method', value: method}));
        }
    });
});
